package kz.dentalcrm.app.screens.positions.add

import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.error_message
import dentalcrm.composeapp.generated.resources.snackbar_position_added
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.domain.PositionsRepository
import kz.dentalcrm.app.screens.positions.add.mvi.AddPositionViewEvent
import kz.dentalcrm.app.screens.positions.add.mvi.AddPositionViewSideEffect
import kz.dentalcrm.app.screens.positions.add.mvi.AddPositionViewState
import kz.dentalcrm.app.theme.SnackbarController
import kz.dentalcrm.app.theme.SnackbarEvent
import org.jetbrains.compose.resources.getString
import org.koin.core.component.inject

class AddPositionViewModel :
    BaseStateViewModel<AddPositionViewEvent, AddPositionViewState, AddPositionViewSideEffect>() {

    private val positionsRepository: PositionsRepository by inject()

    override fun setInitialState() = AddPositionViewState()

    override fun handleEvents(event: AddPositionViewEvent) {
        when (event) {
            is AddPositionViewEvent.AddPosition -> {
                addPosition(event.name, event.description)
            }
            AddPositionViewEvent.Reset -> {
                setState { copy(screenState = AddPositionViewState.ScreenState.Idle) }
            }
        }
    }

    private fun addPosition(name: String, description: String) {
        setState { copy(screenState = AddPositionViewState.ScreenState.Adding) }
        launch(Dispatchers.Default) {
            when (val result = positionsRepository.addPosition(name, description)) {
                is Result.Success -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.snackbar_position_added), SnackbarEvent.SnackbarType.Green))
                    setState { copy(screenState = AddPositionViewState.ScreenState.Added) }
                }
                is Result.Error -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = AddPositionViewState.ScreenState.Error(
                                error = result.message ?: "Error adding position"
                            )
                        )
                    }
                }
                else -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = AddPositionViewState.ScreenState.Error(
                                error = "Unknown error"
                            )
                        )
                    }
                }
            }
        }
    }
}
